import {Button, Tab, Tabs} from "react-bootstrap";
import React, {useEffect, useRef, useState} from "react";
import ThemeData from "../../Interfaces/ThemeData";
import ThemesPopup from "./Theme/ThemesPopup";
import ThemesList from "./Theme/ThemesList";
import SlidesList from "./Slide/SlidesList";
import 'animate.css/animate.css';
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {
    resetOnBoardingShownSteps, setAllowCheckPaymentDone,
    setCurrentSlide,
    setCurrentTab,
    setCurrentTheme, setIsAllMusicUploaded,
    setIsAllPhotosUploaded,
    setIsMusicPlaying,
    setIsPreviewPlaying,
    setOnBoardingShow, setOnBoardingShowReorderPopup,
    setOnBoardingStep,
    setThemeActive, setYmClientId
} from "../../store/makerDataSlice";
import SlideData, {UploadStatus} from "../../Interfaces/SlideData";
import SlidesPopup from "./Slide/SlidesPopup";
import MusicList from "./Music/MusicList";
import Loader from "../Common/Loader";
import {makeTabsStickyHeader} from "../Common/TabsStickyHeader";
import Payment from "./Payment/Payment";
import {useLocation} from "react-router-dom";
import ym from "react-yandex-metrika";
import savePreview from "../../Api/savePreview";
import getPreviewStatus, {canGetPreviewStatus} from "../../Api/getPreviewStatus";
import stopPreview from "../../Api/stopPreview";
import CardCheckbox from "../Common/CardCheckbox";
import {useMutation} from "@tanstack/react-query";
import axios from "axios";
import * as Sentry from "@sentry/react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {SWAL_ALERT_DEFAULTS} from "../../Utils/defaults";
import {store} from "../../store/store";
import OnBoarding from "../Common/OnBoarding";
import {OnBoardingStep} from "../../Interfaces/OnBoardingStep";
import MyVideoList from "./MyVideo/MyVideoList";
import MusicData, {MUSIC_TYPE_USER} from "../../Interfaces/MusicData";

const waitAllPhotosUploadedTimeout = {
    id: null,
};

function MakeTabs() {

    const [wasTabChanged, setWasTabChanged] = useState<boolean>(false);
    const tabsTopRef = useRef<null | HTMLDivElement>(null);
    const makerData = useAppSelector(state => state.makerData)
    const isMakerDataLoaded = useAppSelector(state => state.makerData.isLoaded)
    const themes = useAppSelector(state => state.makerData.themes)
    const currentTheme = useAppSelector(state => state.makerData.currentTheme)
    const currentSlide = useAppSelector(state => state.makerData.currentSlide)
    const videoDuration = useAppSelector(state => state.makerData.videoDuration)
    const stateHash = useAppSelector(state => state.makerData.stateHash)
    const previewId = useAppSelector(state => state.makerData.previewId)
    const previewIdStateHash = useAppSelector(state => state.makerData.previewIdStateHash)
    const previewData = useAppSelector(state => state.makerData.previewData)
    const isPreviewRestored = useAppSelector(state => state.makerData.isPreviewRestored)
    const dispatch = useAppDispatch()

    const urlParams = new URLSearchParams(window.location.search);

    const [tabsKey, setTabsKey] = useState<any | null>()
    const [isThemePopupOpen, setIsThemePopupOpen] = useState<boolean>(false);
    const location = useLocation();
    const [localStateHash, setLocalStateHash] = useState<string>('');

    const mutationSavePreview = useMutation({
        mutationFn: savePreview,
        onError: (error, variables, context) => {
            let errorUrl = '';
            if (axios.isAxiosError(error)) {
                errorUrl = String(error.config?.url);
                // @ts-ignore
            } else if (typeof error?.url !== 'undefined') {
                // @ts-ignore
                errorUrl = error?.url;
            }
            Sentry.captureException(
                // @ts-ignore
                new Error((error?.message ? error.message : 'Failed to save preview. Generic error.') + ', URL: ' + errorUrl),
                {
                    extra: {
                        variables: variables,
                        error: error,
                        responseConfig: axios.isAxiosError(error) ? JSON.stringify(error.response?.config) : '',
                        responseData: axios.isAxiosError(error) ? JSON.stringify(error.response?.data) : ''
                    }
                }
            )
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                ...SWAL_ALERT_DEFAULTS,
                title: 'Ошибка',
                text: 'Ошибка при сохранении проекта. Попробуйте вернуться на вкладку "Мелодия", затем нажать кнопку "Далее".',
                icon: 'error'
            });
        },
        retry: 5,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000)
    })

    const mutationStopPreview = useMutation({
        mutationFn: stopPreview,
        onError: (error, variables, context) => {
            let errorUrl = '';
            if (axios.isAxiosError(error)) {
                errorUrl = String(error.config?.url);
                // @ts-ignore
            } else if (typeof error?.url !== 'undefined') {
                // @ts-ignore
                errorUrl = error?.url;
            }
            Sentry.captureException(
                // @ts-ignore
                new Error((error?.message ? error.message : 'Failed to stop preview. Generic error.') + ', URL: ' + errorUrl),
                {
                    extra: {
                        variables: variables,
                        error: error,
                        responseConfig: axios.isAxiosError(error) ? JSON.stringify(error.response?.config) : '',
                        responseData: axios.isAxiosError(error) ? JSON.stringify(error.response?.data) : ''
                    }
                }
            )
        },
        retry: 5,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000)
    })

    useEffect(() => {
        if (isMakerDataLoaded) {
            // При первом запуске, если localStateHash пустой - берём его из makerData, т.к. там он может быть не пустой,
            // а взятый из localStorage
            if (localStateHash === '' && typeof stateHash !== 'undefined') {
                if (!makerData.isRestoredFromPayedProject) {
                    setLocalStateHash(stateHash);
                }
                // проверяем статус, возможно ушли со страницы пока preview ещё не было готово, а теперь опять вернулись
                if (previewId !== null && previewData?.mainVideo?.isReady !== true) {
                    getPreviewStatus(previewId, dispatch, 0);
                }
            }
        }
    }, [isMakerDataLoaded])

    useEffect(() => {
        // Если восстанавливаем preview - берём пересчитанных хэш после восстановления preview и проверяем статус preview
        if (isPreviewRestored) {
            setLocalStateHash(stateHash);
            // проверяем статус восстановленного preview
            if (previewId !== null) {
                getPreviewStatus(previewId, dispatch, 0);
            }
        }
    }, [isPreviewRestored])

    // При переходе по кнопке "Назад" из Тинькова смотрим статус preview
    const pageShowPreviewStatus = () => {
        if (previewId !== null) {
            getPreviewStatus(previewId, dispatch, 0);
        }
    }
    useEffect(() => {
        window.addEventListener("pageshow", pageShowPreviewStatus);
        return () => {
            window.removeEventListener("pageshow", pageShowPreviewStatus);
        }
    }, []);
    // END


    /**
     * На мобильном, когда scroll вниз - скрывается address bar браузера
     * при этом сходит с ума нижняя плашка с кнопками, которая position: fixed, bottom: 0
     * браузер не понимает, где у неё bottom:0 и плашка перепрыгивает на середину страницы
     * потом, через ещё один scroll возвращается на место.
     * Починилось это, когда у браузера происходит resize (скрывается или показывается address bar)
     * - изменяем плашке bottom=-1, а затем снова bottom=0
     * тогда вроде не проявляется баг
     *
     * !!!!!!!! НИЧЕГО НЕ СРАБОТАЛО, ВСЁ ПЕРЕПРОБОВАЛ, ПУСТЬ ПРЫГАЕТ !!!!!!!!!!!!!!!!!!
     */
    // const fixStickyBottomBarOnMobile = () => {
    //     var elements = document.querySelectorAll('.footer-buttons.sticky-active');
    //     Array.prototype.forEach.call(elements, function(item) {
    //         if (item !== null) {
    //             try {
    //                 // @ts-ignore
    //                 item.style.bottom = '-1px';
    //                 // @ts-ignore
    //                 item.style.bottom = '0px';
    //             } catch (err) {
    //             }
    //         }
    //     });
    // }
    // useEffect(() => {
    //     document.addEventListener("scroll", fixStickyBottomBarOnMobile);
    //     return () => {
    //         window.removeEventListener("scroll", fixStickyBottomBarOnMobile);
    //     }
    // }, []);
    // END


    useEffect(() => {
        setLocalStateHash(stateHash);
        setTabsKey(getTabKeyFromHash(location.hash));
        try {
            ym('getClientID', function(clientId:string) {
                dispatch(setYmClientId(clientId));
            });
        } catch (e) {
            // forgive
        }
    }, [])

    const onTabSelectPayment = async (key: any, forceTop: boolean = false) => {
        switch (key) {
            case 'payment':
                canGetPreviewStatus.value = true;

                // данные проекта изменились (слайды, музыка, тема), запускаем генерацию preview
                if (localStateHash !== stateHash || previewIdStateHash !== stateHash) {
                    setLocalStateHash(stateHash);
                    // если есть previewId и основное видео ещё не готово - останавливаем создание текущего preview
                    if (previewId !== null && previewData?.mainVideo?.isReady !== true) {
                        await mutationStopPreview.mutateAsync({
                            previewId: previewId,
                            dispatch: dispatch
                        });
                    }

                    // Ждём, пока загрузятся все фото
                    if (waitAllPhotosUploadedTimeout.id !== null) clearInterval(waitAllPhotosUploadedTimeout.id);
                    // @ts-ignore
                    waitAllPhotosUploadedTimeout.id = setInterval(() => {
                        let isAllPhotosUploaded = true;
                        // только такой вариант работает внутри setInterval, только так можем
                        // получить актуальный state при каждом цикле interval'а
                        const makerData = store.getState().makerData;
                        makerData.slides.map((slide: SlideData) => {
                            if (slide.type === 'text' || slide.type === 'photo') {
                                if (slide.status !== UploadStatus.ready && slide.status !== UploadStatus.uploadError) {
                                    isAllPhotosUploaded = false;
                                }
                            }
                        });
                        dispatch(setIsAllPhotosUploaded(isAllPhotosUploaded));

                        let isAllMusicUploaded = true;
                        makerData.music.map((music: MusicData) => {
                            if (music.type === MUSIC_TYPE_USER) {
                                if (music.status !== UploadStatus.ready && music.status !== UploadStatus.uploadError) {
                                    isAllMusicUploaded = false;
                                }
                            }
                        });
                        dispatch(setIsAllMusicUploaded(isAllMusicUploaded));

                        if (isAllPhotosUploaded && isAllMusicUploaded) {
                            if (waitAllPhotosUploadedTimeout.id !== null) clearInterval(waitAllPhotosUploadedTimeout.id);

                            // когда все фото загружены -
                            // запускаем создание нового preview
                            mutationSavePreview.mutate({
                                makerData: makerData,
                                dispatch: dispatch
                            });
                            dispatch(setIsPreviewPlaying(false));

                        }
                    }, 200);
                } else {
                    // проверяем статус, возможно ушли с вкладки Payment, а теперь опять вернулись
                    if (previewId !== null && previewData?.mainVideo?.isReady !== true) {
                        getPreviewStatus(previewId, dispatch, 0);
                    }
                }
                break;
            default:
                // если ушли на другую вкладку - не дёргаем previewStatus
                canGetPreviewStatus.value = false;
                dispatch(setIsPreviewPlaying(false));
                break;
        }
    };

    /**
     * ------------------------------
     * ДЕЛАЕМ, ЧТОБЫ СКРОЛЛ У КАЖДОГО ТАБА СОХРАНЯЛСЯ и проматывался к тому месту, в котором был
     * при переключении таба
     */
    const [scrollThemesTab, setScrollThemesTab] = useState<number | null>(null);
    const [scrollSlidesTab, setScrollSlidesTab] = useState<number | null>(null);
    const [scrollMusicTab, setScrollMusicTab] = useState<number | null>(null);

    const onScrollThemes = React.useCallback(() => {
        setScrollThemesTab(window.scrollY);
    }, [])
    const onScrollSlides = React.useCallback(() => {
        setScrollSlidesTab(window.scrollY);
    }, [])
    const onScrollMusic = React.useCallback(() => {
        setScrollMusicTab(window.scrollY);
    }, [])
    /**
     * когда первый раз загрузили приложение - подписываемся на scroll
     * после этого, каждый раз, когда переключаются табы (ниже, в onTabSelect) - отписываемся
     * и подписываемся заново в зависимости от выбранного таба.
     * только так срабатывало.
     */
    useEffect(() => {
        switch (tabsKey) {
            case 'themes':
                window.addEventListener('scroll', onScrollThemes);
                break;
            case 'slides':
                window.addEventListener('scroll', onScrollSlides);
                break;
            case 'music':
                window.addEventListener('scroll', onScrollMusic);
                break;
        }
    }, []);

    const onTabSelect = (key: any, forceTop: boolean = false) => {
        setWasTabChanged(true);
        setTabsKey(key);
        dispatch(setCurrentTab(key));
        dispatch(setAllowCheckPaymentDone(false));
        window.history.pushState({}, '', '#' + key);
        dispatch(setIsMusicPlaying(false));
        window.removeEventListener('scroll', onScrollThemes);
        window.removeEventListener('scroll', onScrollSlides);
        window.removeEventListener('scroll', onScrollMusic);
        let scrollValue: number | null = null;
        let scrollListener = null;
        switch (key) {
            case 'themes':
                scrollValue = scrollThemesTab;
                scrollListener = onScrollThemes;
                break;
            case 'slides':
                scrollValue = scrollSlidesTab;
                scrollListener = onScrollSlides;
                break;
            case 'music':
                scrollValue = scrollMusicTab;
                scrollListener = onScrollMusic;
                break;
        }
        if (forceTop) {
            tabsTopRef.current!.scrollIntoView({behavior: 'smooth'});
        } else {
            if (scrollValue != null) {
                setTimeout(() => {
                    window.scroll({left: 0, top: scrollValue as number, behavior: 'smooth'})
                }, 50);
            } else {
                tabsTopRef.current!.scrollIntoView({behavior: 'smooth'});
            }
        }
        if (scrollListener != null) {
            window.addEventListener('scroll', scrollListener);
        }
    }
    /**
     * КОНЕЦ своего скролла у каждого таба
     * -----------------------------------
     */

    useEffect(() => {
        dispatch(setIsPreviewPlaying(false));
        setTabsKey(getTabKeyFromHash(location.hash));
        // destroy'им все MySwal при нажатии на кнопку Назад в браузере
        const MySwal = withReactContent(Swal);
        MySwal.close();
    }, [location]);

    const onThemeItemClick = (theme: ThemeData) => {
        dispatch(
            setCurrentTheme(theme)
        )
        setIsThemePopupOpen(true)
        ym('reachGoal', 'playTheme');
    }

    const onThemeSelect = (theme: ThemeData) => {
        dispatch(
            setThemeActive(theme)
        )
        setIsThemePopupOpen(false);
        onTabSelect('slides', true);
    }

    useEffect(() => {
        makeTabsStickyHeader();

        if (isMakerDataLoaded && makerData.cardSlugTmp !== null) {
            if (getTabKeyFromHash(location.hash) == 'payment') {
                setTabsKey('payment');
            } else {
                setTabsKey('slides');
                dispatch(setCurrentTab('slides'));
            }
        }
    }, [isMakerDataLoaded]);

    const getTabKeyFromHash = (hash: string) => {
        if (hash.substring(1)) {
            let hash2 = hash.substring(1);
            // поддержка старых hash'ей
            switch (hash2) {
                case 'tabSlides':
                    return 'slides';
                case 'tabMusic':
                    return 'music';
                case 'tabThemes':
                    return 'themes';
            }
            // если есть такой таб
            if (['themes', 'slides', 'music', 'payment', 'my-video'].indexOf(hash2) > -1) {
                dispatch(setCurrentTab(hash2));
                return hash2;
            }
            if (hash2.startsWith('vk-preview-redirect-')) {
                dispatch(setCurrentTab('payment'));
                return 'payment';
            }
            dispatch(setCurrentTab('themes'));
            return 'themes';
        } else {
            dispatch(setCurrentTab('themes'));
            return 'themes';
        }
    }

    const onQuestionClick = () => {
        dispatch(setOnBoardingShowReorderPopup(undefined));
        dispatch(setOnBoardingShow(true));
        dispatch(resetOnBoardingShownSteps());
        switch (makerData.currentTab) {
            case 'themes':
                dispatch(setOnBoardingStep(OnBoardingStep.themes));
                break;
            case 'slides':
                dispatch(setOnBoardingStep(OnBoardingStep.slides));
                break;
            case 'music':
                dispatch(setOnBoardingStep(OnBoardingStep.music));
                break;
            case 'payment':
                if (makerData.previewData !== null) {
                    dispatch(setOnBoardingStep(OnBoardingStep.payment));
                }
                break;
        }
    }

    return (
        <div>
            {isMakerDataLoaded
                ? (
                    <div className={`tabs active-tab-${tabsKey}`}>
                        <OnBoarding/>
                        <div ref={tabsTopRef} className={'tabs-top-sticky-empty'}></div>
                        <Tabs
                            activeKey={tabsKey}
                            onSelect={(key) => {
                                onTabSelect(key, false);
                                onTabSelectPayment(key, false);
                            }}
                            id="makeTabs"
                            className="mb-3"
                        >
                            <Tab eventKey="themes" title={<span>
                                <span className={'step-number'}><span className={'step-inner'}>1</span></span>
                                <span className={'lg'}>Тема слайдшоу</span><span className={'sm'}>Тема</span>
                            </span>} tabClassName={'tab-item tab-themes'}>
                                {/* ------------------------ */}
                                <ThemesList
                                    themes={themes}
                                    currentTheme={currentTheme}
                                    currentTab={tabsKey}
                                    onClickAction={onThemeItemClick}
                                    onSelectThemeAction={onThemeSelect}>
                                </ThemesList>
                                {/* ------------------------ */}
                                <div className={'tabs-bottom-sticky-empty themes'}/>
                                <div className={'footer-buttons themes container'}>
                                    <div className={'row row-buttons'}>
                                        <div className={'col-6 text-left'}>
                                            <Button
                                                className={'question'}
                                                size={"lg"}
                                                onClick={() => onQuestionClick()}>
                                                <i className="fa fa-regular fa-circle-question"></i>
                                            </Button>
                                        </div>
                                        <div className={'col-6 text-right'}>
                                            <CardCheckbox/>
                                            <Button
                                                className={'next'}
                                                size={"lg"}
                                                onClick={() => onTabSelect('slides')}>
                                                Далее
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="slides" title={<span>
                                <span className={'step-number'}><span className={'step-inner'}>2</span></span>
                                <span className={'lg'}>Фото и текст</span><span className={'sm'}>Фото</span>
                            </span>} tabClassName={'tab-item tab-slides'}>
                                {/* ------------------------ */}
                                <SlidesList/>
                                {/* ------------------------ */}
                                <div className={'tabs-bottom-sticky-empty slides'}/>
                                <div className={'footer-buttons slides container'}>
                                    <div className={'row'}>
                                        {videoDuration ?
                                            <div className={'col-12 text-right video-duration video-duration-top'}
                                                 id={'video-duration-top'}>
                                                <span>
                                                    <span>Длительность видео: </span>
                                                    <span><b>{videoDuration.minutes}</b> мин. </span>
                                                    <span><b>{videoDuration.seconds}</b> сек. </span>
                                                </span>
                                            </div>
                                            :
                                            <div className={'col-12 text-right video-duration video-duration-top'}
                                                 id={'video-duration-top'}>
                                                <span>Длительность видео: 0 сек. Добавьте слайды.</span>
                                            </div>
                                        }
                                    </div>
                                    <div className={'row row-buttons'}>
                                        <div className={'col-6 text-left'}>
                                            <Button
                                                className={'prev'}
                                                size={"lg"}
                                                onClick={() => onTabSelect('themes')}>
                                                Назад
                                            </Button>
                                            <Button
                                                className={'question'}
                                                size={"lg"}
                                                onClick={() => onQuestionClick()}>
                                                <i className="fa fa-regular fa-circle-question"></i>
                                            </Button>
                                        </div>
                                        <div className={'col-6 text-right'}>
                                            <div className={'video-duration-right-box'}>
                                                {videoDuration ?
                                                    <div className={'video-duration video-duration-right'}
                                                         id={'video-duration-right'}>
                                                        <span>
                                                            <span>Длительность видео: </span>
                                                            <span><b>{videoDuration.minutes}</b> мин. <b>{videoDuration.seconds}</b> сек.</span>
                                                        </span>
                                                    </div>
                                                    :
                                                    <div className={'video-duration video-duration-right'}
                                                         id={'video-duration-right'}>
                                                        <span>Длительность видео: 0 сек. <br/>Добавьте слайды.</span>
                                                    </div>
                                                }
                                                <CardCheckbox/>
                                                <Button
                                                    className={'next'}
                                                    size={"lg"}
                                                    onClick={() => onTabSelect('music')}>
                                                    Далее
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="music" title={<span>
                                <span className={'step-number'}><span className={'step-inner'}>3</span></span>
                                Мелодия
                            </span>} tabClassName={'tab-item tab-music'}>
                                {/* ------------------------ */}
                                <MusicList/>
                                {/* ------------------------ */}
                                <div className={'tabs-bottom-sticky-empty music'}/>
                                <div className={'footer-buttons music container'}>
                                    <div className={'row'}>
                                        {videoDuration ?
                                            <div className={'col-12 text-right video-duration video-duration-top'}
                                                 id={'video-duration-top'}>
                                                <span>
                                                    <span>Длительность видео: </span>
                                                    <span><b>{videoDuration.minutes}</b> мин. </span>
                                                    <span><b>{videoDuration.seconds}</b> сек. </span>
                                                </span>
                                            </div>
                                            :
                                            <div className={'col-12 text-right video-duration video-duration-top'}
                                                 id={'video-duration-top'}>
                                                <span>Длительность видео: 0 сек. Добавьте слайды.</span>
                                            </div>
                                        }
                                    </div>
                                    <div className={'row row-buttons'}>
                                        <div className={'col-6 text-left'}>
                                            <Button
                                                className={'prev'}
                                                size={"lg"}
                                                onClick={() => onTabSelect('slides')}>
                                                Назад
                                            </Button>
                                            <Button
                                                className={'question'}
                                                size={"lg"}
                                                onClick={() => onQuestionClick()}>
                                                <i className="fa fa-regular fa-circle-question"></i>
                                            </Button>
                                        </div>
                                        <div className={'col-6 text-right'}>
                                            <div className={'video-duration-right-box'}>
                                                {videoDuration ?
                                                    <div className={'video-duration video-duration-right'}
                                                         id={'video-duration-right'}>
                                                        <span>
                                                            <span>Длительность видео: </span>
                                                            <span><b>{videoDuration.minutes}</b> мин. <b>{videoDuration.seconds}</b> сек.</span>
                                                        </span>
                                                    </div>
                                                    :
                                                    <div className={'video-duration video-duration-right'}
                                                         id={'video-duration-right'}>
                                                        <span>Длительность видео: 0 сек. <br/>Добавьте слайды.</span>
                                                    </div>
                                                }
                                                <CardCheckbox/>
                                                <Button
                                                    className={'next'}
                                                    size={"lg"}
                                                    onClick={() => {
                                                        onTabSelect('payment');
                                                        onTabSelectPayment('payment');
                                                    }}>
                                                    Далее
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="payment" title={<span>
                                <span className={'step-number'}><span className={'step-inner'}>4</span></span>
                                Готово!
                            </span>} tabClassName={'tab-item tab-done'}>
                                {/* ------------------------ */}
                                <Payment
                                    isVisible={tabsKey == 'payment'}
                                    onGotoSlidesTab={() => onTabSelect('slides')}
                                    onGotoMyVideoTab={() => {
                                        onTabSelect('my-video', false);
                                        onTabSelectPayment('my-video', false);
                                    }}
                                />
                            </Tab>
                            <Tab eventKey="my-video" title={<span>Мои видео</span>}
                                 tabClassName={'tab-item tab-my-video'}
                            >
                                {/* ------------------------ */}
                                <MyVideoList
                                    vkUserProjects={makerData.vkUserProjects}
                                    currentTab={tabsKey}>
                                </MyVideoList>
                                {/* ------------------------ */}
                            </Tab>
                        </Tabs>
                        {
                            typeof makerData.vkUserProjects !== 'undefined' && makerData.vkUserProjects.length > 0 ?
                                <Button
                                    className={`button-tab-my-video-absolute ${tabsKey === 'my-video' ? 'active' : ''}`}
                                    size={"lg"}
                                    onClick={() => {
                                        onTabSelect('my-video', false);
                                        onTabSelectPayment('my-video', false);
                                    }}>
                                    {/*<i className="fa fa-regular fa-play-circle"></i>*/}
                                    Мои<br/>видео
                                </Button> : ''
                        }
                        {currentTheme && (
                            <ThemesPopup
                                isPopupOpen={isThemePopupOpen}
                                onCloseRequest={() => {
                                    setIsThemePopupOpen(false);

                                    // закрыли Popup без выбора темы - ставим currentTheme ту, которая была выбрана
                                    dispatch(
                                        setCurrentTheme(makerData.themes.filter((theme: ThemeData) => {
                                            return theme.isActive;
                                        })[0])
                                    )
                                }}
                                onSelectThemeAction={onThemeSelect}
                            >
                            </ThemesPopup>
                        )}
                        {currentSlide && (
                            <SlidesPopup
                                onCloseRequest={() => {
                                    dispatch(
                                        setCurrentSlide(null)
                                    )
                                }}
                                setCurrentSlide={(slide: SlideData) => {
                                    dispatch(
                                        setCurrentSlide(slide)
                                    )
                                }}
                            >
                            </SlidesPopup>
                        )}
                    </div>
                )
                : (
                    <div>
                        <Loader showProgress={false}
                                isLoaded={false}
                                background={'#ffffff'}/>
                        <div className={'main-loader-text-container'}>
                            <span className={'main-loader-text'}>Идёт загрузка, пожалуйста подождите.</span>
                        </div>
                    </div>
                )
            }
        </div>
    );
}

export default MakeTabs;